import { initialState } from "./state"

export default {
  updateContractsListOptions: (state, payload) => state.contractsListOptions = payload,
  updateSelectedContract: (state, payload) => state.selectedContract = payload,
  resetBiometryContract: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
